import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ButtonPrimary from "../../../components/button/ButtonPrimary";
import { useLocation, useNavigate } from "react-router-dom";
import { searchAPI } from "../../../apis";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { axiosInstance } from "../../../functions/axios";

const CollectionConfirmation = () => {
  const [showPopup, setShowPopup] = useState(true);
  const { user } = useSelector((state) => state.auth);

  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const code = queryParams.get("code");
  const collectionName = queryParams.get("collectionName");
  console.log("Inside shared collection");

  const handleSave = async () => {
    setShowPopup(false);
    try {
      const res = await axiosInstance.get(
        `${searchAPI.confirmSharedCollection}?code=${code}&userId=${user.userId}`,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      navigate(`/saved/${res.data.collectionID_ids}`);
    } catch (e) {
      if (e.response.data.title === "Unauthorized") {
        toast.error(
          "Sorry you are unauthorised to perform the following action."
        );
      }
      navigate(`/saved/0`);
    } finally {
      localStorage.removeItem("code");
      localStorage.removeItem("collectionName");
    }
  };

  useEffect(() => {
    if (!localStorage.getItem("user")) {
      localStorage.setItem("code", code);
      localStorage.setItem("collectionName", collectionName);
      toast.error("Please log in to accept or reject this shared collection");
      navigate("/");
    }
  }, []);

  return (
    showPopup &&
    localStorage.getItem("user") && (
      <>
        <div className="saved-page">
          <div className="share-collection-popup">
            <div className="bg-dark" />
            <div className="popup-card">
              <CloseIcon
                className="cross"
                onClick={() => setShowPopup(false)}
              />
              <p className="popup-title">
                Do you want to accept the Collection {collectionName} that has
                been shared with you?
              </p>
              <div className="save-actions">
                <div />
                <div className="flex">
                  <ButtonPrimary
                    text="No"
                    onClick={() => setShowPopup(false)}
                    className="mr-2 grey"
                    outline
                  />
                  <ButtonPrimary text="Yes" onClick={handleSave} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  );
};

export default CollectionConfirmation;
